// @flow

import _ from 'lodash';

import ArrayUtils from '../../utils/ArrayUtils';
import Utils from '../../utils/Utils';

import ApiObject from '../ApiObject';
import CategoryItem from './CategoryItem';
import SuggestedItem from './SuggestedItem';
import Menu from './Menu';
import Product from './Product';

export default class ItemSuggestion extends ApiObject {

  get id(): string {
    if (_.isNil(this.item)) {
      return '';
    }
    return this.item.id;
  }

  item: CategoryItem;

  linkedItems: Array<SuggestedItem> = [];

  postJsonAssignation(data: Object) {
    this.linkedItems = [];
    _.each(data.linkedItems, (itemData) => {
      const item: SuggestedItem = new SuggestedItem();
      item.fromJson(itemData);
      this.linkedItems.push(item);
    });

    this.item = new CategoryItem();
    this.item.fromJson(data.item);
  }

  setItem(categoryItem: CategoryItem) {
    this.item = categoryItem;
  }

  addLinkedItem(categoryItem: CategoryItem) {
    this.linkedItems.push(categoryItem);
  }

  removeLinkedItemWithId(id: string) {
    this.linkedItems = _.remove(this.linkedItems, (item: CategoryItem) => {
      return item.id !== id;
    });
  }

  addLinkedProduct(product: Product) {
    const item: CategoryItem = new CategoryItem();
    item.id = product.id;
    item.type = CategoryItem.Type.PRODUCT;
    this.linkedItems.push(item);
  }

  addLinkedMenu(menu: Menu) {
    const item: CategoryItem = new CategoryItem();
    item.id = menu.id;
    item.type = CategoryItem.Type.MENU;
    this.linkedItems.push(item);
  }

  getLinkedItemWithId(id: string) {
    return ArrayUtils.find(this.linkedItems, { id });
  }

}



// WEBPACK FOOTER //
// ./sdk/scripts/entities/menu/ItemSuggestion.js